import React from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';

// components
import History from './History';
import PatternsModal from './PatternsModal';
import DetailsModal from './DetailsModal';

/*
function NavButton({ title, path }) {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const active = (path === pathname);

  return (
    <button
      type="button"
      className={`btn btn-outline-primary fw-bold me-3 ${active ? 'active' : ''}`}
      onClick={() => navigate(path)}
    >
      {title}
    </button>
  );
}
*/

function LayoutRow({ children, className = '' }) {
  return (
    <div className={`row border border-light bg-white py-3 ${className}`}>
      {children}
    </div>
  );
}

function RTS() {
  return (
    <main className="p-5">
      <LayoutRow>
        <div className="d-flex col justify-content-center">
          <h3>RTS Processing History</h3>
        </div>
      </LayoutRow>
      <LayoutRow className="mt-3">
        <History />
      </LayoutRow>
      <PatternsModal />
      <DetailsModal />
    </main>
  );
}

export default RTS;
